import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { MAVLINK_MESSAGE_IDS as MAVLINK_MSG } from '@/define/messageId';
import { MODE, ROBOT_STATUS } from '@/define/robotStatus';
import useRobotTelemetry from '@/hooks/useRobotTelemetry';

// MavLink 프로토콜을 사용하는 드론의 제조사별, 기체별 모드 매핑
const MAVLINK_MODE_MAP = {
  ArduPilot: {
    Copter: MODE.ARDUPILOT.COPTER,
    Plane: MODE.ARDUPILOT.PLANE,
  },
  PX4: {
    Rover: MODE.PX4.ROVER,
  },
};

// statusCode를 기반으로 시스템 상태명 반환
const getSystemStatusMode = (statusCode) => {
  return Object.values(ROBOT_STATUS).find(({ code }) => code === statusCode)?.name || null;
};

// statusCode, heartbeat mode에 따른 모드 반환
const getMode = (robotModel, statusCode, heartbeatMode) => {
  const { maker, vehicle } = robotModel;

  // heartbeat mode 있으면 반환
  if (heartbeatMode !== null) {
    const vehicleModes = MAVLINK_MODE_MAP[maker][vehicle];

    return Object.values(vehicleModes).find(({ id }) => id === heartbeatMode)?.name || null;
  }

  // MavLink에서 모드가 정의되지 않은 경우 시스템 상태 반환
  return getSystemStatusMode(statusCode);
};

// 로봇의 현재 모드를 반환하는 커스텀 훅
const useModeByStatus = (robot) => {
  const statusCode = useSelector((state) => state.robotStatus[robot.id]?.code);
  const heartbeatMode = useRobotTelemetry(robot.id, MAVLINK_MSG.HEARTBEAT)?.mode;

  const mode = useMemo(() => {
    return getMode(robot.model, statusCode, heartbeatMode);
  }, [robot.model, statusCode, heartbeatMode]);

  return mode;
};

export default useModeByStatus;
